<template>
  <div class="payment-create main-content">
    <div class="page-header">
      <h3 class="page-title">
        {{ $t("prepayments.view_invoice_prepayment") }}
      </h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/super-admin/dashboard"
            v-if="userType == 'super_admin'"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            slot="item-title"
            to="/supplier/dashboard"
            v-else-if="userType == 'supplier'"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            slot="item-title"
            to="/anchor/dashboard"
            v-else-if="userType == 'anchor'"
            >{{ $t("general.home") }}</router-link
          >
          <router-link
            slot="item-title"
            to="/funder/dashboard"
            v-else-if="userType == 'funder'"
            >{{ $t("general.home") }}</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/super-admin/invoices"
            v-if="userType == 'super_admin'"
            >{{ $tc("invoices.invoice", 2) }}</router-link
          >
          <router-link
            slot="item-title"
            to="/supplier/invoices"
            v-else-if="userType == 'supplier'"
            >{{ $tc("invoices.invoice", 2) }}</router-link
          >
          <router-link
            slot="item-title"
            to="/anchor/invoices"
            v-else-if="userType == 'anchor'"
            >{{ $tc("invoices.invoice", 2) }}</router-link
          >
          <router-link
            slot="item-title"
            to="/funder/invoices"
            v-else-if="userType == 'funder'"
            >{{ $tc("invoices.invoice", 2) }}</router-link
          >
        </li>

        <li class="breadcrumb-item">
          {{ $t("prepayments.view_invoice_prepayment") }}
        </li>
      </ol>
    </div>
    <SinglePreapprovedInvoiceRow
      v-if="
        $route.name === 'preapproved-invoice-request-view-supplier' ||
          $route.name === 'preapproved-invoice-request-view-anchor' ||
          $route.name === 'preapproved-invoice-request-view-funder' ||
          $route.name === 'preapproved-invoice-request-view'
      "
      :fetchData="fetchData"
    />
    <SingleInvoiceRow v-else :fetchData="fetchData" />
    <SingleRequestRow :prepaymentRequest="prepaymentRequest" />
  </div>
</template>

<script>
import SingleInvoiceRow from "../invoices/SingleInvoiceRow";
import SingleRequestRow from "./SinglePrepaymentRequestRow";
import SinglePreapprovedInvoiceRow from "../preapprovedInvoices/SingleInvoiceRow.vue";

import { mapActions, mapGetters } from "vuex";
import MultiSelect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import moment from "moment";
const {
  required,
  between,
  maxLength,
  numeric
} = require("vuelidate/lib/validators");

export default {
  components: {
    MultiSelect,
    SingleInvoiceRow,
    SingleRequestRow,
    SinglePreapprovedInvoiceRow
  },
  mixins: [validationMixin],
  data() {
    return {
      userType: null,
      fetchData: [],
      prepaymentRequest: [],
      isLoading: false
    };
  },
  created() {
    if (localStorage.getItem("role") == "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") == "anchor") {
      this.userType = "anchor";
    } else if (localStorage.getItem("account_type") == "supplier") {
      this.userType = "supplier";
    } else if (localStorage.getItem("account_type") == "funder") {
      this.userType = "funder";
    }
    this.loadInvoice();
    this.loadRequest();
  },
  validations() {
    return {};
  },
  computed: {},
  watch: {},
  async mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    ...mapActions("invoice", ["fetchInvoice", "SingleInvoiceArray"]),
    ...mapActions("prepayment", ["fetchPrePaymentRequest", "fetchPrePayment"]),
    async loadInvoice() {
      let response = await this.SingleInvoiceArray(this.$route.params.id);
      if (response.data) {
        this.fetchData = response.data.invoice;
      }
    },
    async loadRequest() {
      if (this.$route.params.id) {
        let res = await this.fetchPrePaymentRequest(this.$route.params.id);
        if (res.data) {
          this.prepaymentRequest = res.data.prepaymentRequest;
        }
      }
    }
  }
};
</script>
<style scoped>
.table-component {
  min-height: 0px;
}
</style>
